import { useNavigate } from 'react-router-dom';
import { useLeaveSiteConfirm } from '../components/ui/LeaveSiteConfirm';

/** Click handler for a link that should show a "you're leaving this site"
 * confirmation dialog before navigating, when `confirmLeave` is set.
 * When `confirmLeave` is falsy, returns undefined so the element keeps its
 * native <a>/<Link> click behavior (new-tab, copy-link, etc.) untouched. */
export function useConfirmableLinkClick(href: string | undefined, confirmLeave: boolean | undefined) {
  const navigate = useNavigate();
  const { requestLeave } = useLeaveSiteConfirm();

  if (!href || !confirmLeave) return undefined;

  return (e: React.MouseEvent) => {
    e.preventDefault();
    const isExternal = /^https?:\/\//.test(href);
    requestLeave(() => {
      if (isExternal) window.open(href, '_blank', 'noopener,noreferrer');
      else navigate(href);
    });
  };
}
